import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import Activity from './Activity'

const { ExportCSVButton } = CSVExport;


const Activities = props => {

  const [loading, setLoading] = React.useState(true);
  const [deleting, setDeleting] = React.useState(false);
  const [deleteThis, setDeleteThis] = React.useState(null);
  const [forceDeleteThis, setForceDeleteThis] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [id, setId] = React.useState(null);

  const selectOptions = {
    0: 'Inactive',
    1: 'Active',
    // 2: '-'
  };

  const toggleView = () => setId(null);
  const toggleDel = () => setDeleteThis(null);
  const toggleForceDel = () => setForceDeleteThis(null);

  const weekVals = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_ACTIVITIES+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data);
        setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  React.useEffect(()=>{
    console.log(props.filterBlock);
    if(props.filterBlock) {
    fetchData();
    }
  }, [props.filterBlock]);


  const handleDelete = (force) => {
    let formdata = {
      id: force ? forceDeleteThis.id : deleteThis.id,
      force,
    };
    setDeleting(true);
    post(url.DELETE_ACTIVITY, formdata)
    .then((response) => {
      console.log('DEL RESP', response);
      if(response.status == 200) {
        cogoToast.success('Activity deleted');
        setDeleteThis(null);
        setForceDeleteThis(null);
        fetchData();
      }
      else if(response.status == 409) {
        setForceDeleteThis(JSON.parse(JSON.stringify(deleteThis)));
        setDeleteThis(null);
      }
      else {
        console.log('err::', response);
        cogoToast.error('Activity could not be deleted');
      }
      setDeleting(false);
    }, (error) => {
      console.log(error);
      cogoToast.error('Activity could not be deleted');
      setDeleting(false);
    });

  };

  const columns = [{
    dataField: 'slno',
    text: '#'
  }, {
    dataField: 'activity_code',
    text: 'Activity Code',
    sort: true,
    filter: textFilter(),
  }, {
  text: 'Form Name',
    dataField: 'form.name',
  sort: true,
  filter: textFilter(),
  }, {
    text: 'Activity Name',
    dataField: 'name',
    sort: true,
    filter: textFilter(),
    }, 
  {
    text: 'Activity Type',
    dataField: 'servicetype.name',
    sort: true,
    filter: textFilter(),
  // }, 
  // {
  //   text: 'Assets',
  //   dataField: 'assets.length',
  //   sort: true,
  //   filter: textFilter(),
  // }, {
  //   text: 'Frequency',
  //   dataField: 'frequency.type',
  //   sort: true,
  //   filter: textFilter(),
    
    
  //   {
  //   dataField: 'id',
  //   text: '#'
  // }, {
  //   dataField: 'name',
  //   text: 'Activity Name',
  //   sort: true,
  //   filter: textFilter(),
  // }, 
  // {
  //   dataField: 'blocks_count',
  //   text: 'No. of Blocks',
  //   sort: true,
  //   filter: textFilter(),
  // }, 
  // {
  //   dataField: 'status',
  //   formatter: cell => selectOptions[cell],
  //   csvFormatter: cell => selectOptions[cell],
  //   filter: selectFilter({
  //     options: selectOptions,
  //     placeholder: 'All Statuses'
  //   }),
  //   text: 'Status',
  }, 
  {
    dataField: 'id',
    text: 'Actions',
    formatter: (cell, row, rowIndex)=> {
      return <div className="d-flex">
        <Button color="link" title="View details" onClick={()=>{
          setId(row.id);
        }}>
          <i className="bx bx-info-circle" style={{color: '#667CE8', fontSize: 19,}}></i>
        </Button>{' '}
          <Link className="btn" to={{pathname: "/activities/edit/"+row.id, query: row}}>
            <i className="bx bx-pencil" style={{color: '#667CE8', fontSize: 19,}}></i>
          </Link>{' '}
        <Button color="link" title="Delete" onClick={()=>{
        setDeleteThis(row);
        }}><i className="bx bx-trash" style={{color: 'rgb(231, 119, 147)', fontSize: 19,}}></i></Button>
      </div>;
    },
    csvExport: false,
  },
  ];


  const expandRow = {
    renderer: row => (
      <div className="ps-5">
        {/* {JSON.stringify(row)} */}
        <table className="table table-nested">
          <thead>
            <tr>
              <th>Assets</th>
              <th>Frequency type</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Time slots</th>
              <th>Repeat every</th>
            </tr>
          </thead>
          <tbody>
            {row.frequencies.map((freq, freqIdx)=>(
              <tr key={freqIdx}>
                <td>{freq.assets.map((fAsset, fAssetIdx)=>(
                  <div key={fAssetIdx}>{fAsset.name}</div>
                ))}</td>
                <td>
                  <div>{freq.type}</div>
                  {freq.type == 'Weekly' &&
                  <div>{JSON.parse(freq.daysofweek).map((dow, dowIdx)=>(
                    <span key={dowIdx} style={{paddingRight: 4, color: dow ? 'rgb(81, 168, 81)' : 'rgb(221, 125, 125)'}}>
                      {weekVals[dowIdx]}
                    </span>
                  ))}</div>
                  }
                  {freq.type == 'Monthly' &&
                  <div className="d-flex flex-row flex-wrap">{JSON.parse(freq.daysofmonth).map((dom, domIdx)=>(
                    <div key={domIdx} style={{paddingRight: 4, color: dom ? 'rgb(81, 168, 81)' : 'rgb(221, 125, 125)'}}>
                      {domIdx+1}
                    </div>
                  ))}</div>
                  }
                </td>
                <td>{freq.startdate}</td>
                <td>{freq.enddate}</td>
                <td>{JSON.parse(freq.timeslots).map((fSlot, fSlotIdx)=>(
                  <div key={fSlotIdx}>{fSlot.start.substring(0,5)} - {fSlot.end.substring(0,5)}</div>
                ))}</td>
                <td>{freq.interval} {freq.type == 'Daily' ? 'day' : (freq.type == 'Weekly' ? 'week' : 'month')}{freq.interval > 1 && 's'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      // if (isAnyExpands) {
      //   return <b>-</b>;
      // }
      return '';
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <b><i className="bx bxs-minus-circle" style={{color: '#667CE8', fontSize: 22,}}></i></b>
        );
      }
      return (
        <b><i className="bx bxs-plus-circle" style={{color: '#667CE8', fontSize: 22,}}></i></b>
      );
    },
  };



  const createExportAllHandler = ({ onExport }) => () => {
    onExport(data);
  };

  const noData = <div className="text-muted py-3 text-center">{props.filterBlock ? 'No data to display' : "Please select Property and Block"}</div>

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Activities | Digital Logbook</title>
        </MetaTags>
        <Container fluid>

          <ToolkitProvider
            keyField="id"
            data={ data }
            columns={ columns }
            exportCSV={ {
              fileName: 'activities.csv',
              // separator: '|',
              // ignoreHeader: true,
              // noAutoBOM: false
              exportAll: false,
            } }
          >
            {
              props => (
          <React.Fragment>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h3 className="mb-4">Activities ({data.length})</h3>
              <div className="d-flex justify-content-end align-items-center">
                <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } 
                  onClick={createExportAllHandler(props.csvProps) }  >Export All</ExportCSVButton>
                <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } 
                  >Export Visible</ExportCSVButton>
                <Link className="btn btn-primary" to={{pathname: "/activities/new", query: {id: 'new'}}}>Create New</Link>
              </div>
            </div>

            <Card>
              <CardBody>
                    <div>
                      <hr />
                      <BootstrapTable 
                        { ...props.baseProps }
                        keyField='id'
                        data={ data }
                        filter={ filterFactory() }
                        pagination={ paginationFactory() } 
                        expandRow={ expandRow }
                        noDataIndication={noData}
                        />
                      {/* <BootstrapTable { ...props.baseProps } /> */}
                    </div>


              </CardBody>
            </Card>
          </React.Fragment>
          )
        }
        </ToolkitProvider>
        </Container>
      </div>
      { id !== null &&
        <Activity id={id} isOpen={id !== null} toggle={toggleView} />
      }
      { deleteThis !== null &&
      <Modal isOpen={deleteThis !== null} centered>
        <ModalHeader toggle={toggleDel}>Confirmation</ModalHeader>
        <ModalBody>
          Are you sure you want to delete {deleteThis.name}?
          <br />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={deleting} onClick={() => {handleDelete(false)}}>Delete</Button>{' '}
          <Button color="link" onClick={toggleDel}>Cancel</Button>
        </ModalFooter>
      </Modal>}
      
      { forceDeleteThis !== null &&
      <Modal isOpen={forceDeleteThis !== null} centered>
        <ModalHeader toggle={toggleForceDel}>Warning</ModalHeader>
        <ModalBody>
          Activity contains tasks. Deleting will also clear all the associated data.
          <br />
          Proceed? 
          <br />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={deleting} onClick={() => { handleDelete(true); }}>Yes, Delete</Button>{' '}
          <Button color="link" onClick={toggleForceDel}>Cancel</Button>
        </ModalFooter>
      </Modal>}

    </React.Fragment>
  )
}


const mapStatetoProps = (state) => {
  const {
    filterBlock,
  } = state.filters
  return { filterBlock }
}

export default connect(mapStatetoProps)(Activities)